import React from 'react';

import { IconX } from '@trqk/components';
import { locale } from '@trqk/utils';
import entitySelectorImg from '../../../../assets/png/entity_selector_screenshot.png';

/**
 * Renders some help text about how the Entity Selector works. Intended for use within the tooltip
 * in the EntityManager section.
 */
export const EntitySelectorTooltipContent = ({
    close,
}: RenderTooltipMessageProps): JSX.Element => (
    <div className="pb-4">
        <div className="flex justify-end px-2 pt-2">
            <IconX
                addClasses="respond-to-mouse"
                width={16}
                fillColor="tertiary-400"
                handleClick={close}
            />
        </div>
        <div className="mx-6">
            <div className="font-bold mt-2 mb-4">
                {
                    locale.enUS.ACCOUNT.SECTIONS.ENTITY_MANAGER
                        .ENTITY_SELECTOR_TOOLTIP.TITLE
                }
            </div>
            <img
                src={entitySelectorImg}
                alt={
                    locale.enUS.ACCOUNT.SECTIONS.ENTITY_MANAGER
                        .ENTITY_SELECTOR_TOOLTIP.IMG_ALT
                }
                className="mt-3 mb-4"
            />
            <div>
                {
                    locale.enUS.ACCOUNT.SECTIONS.ENTITY_MANAGER
                        .ENTITY_SELECTOR_TOOLTIP.BODY
                }
            </div>
        </div>
    </div>
);
